<nb-layout>
    <nb-layout-header style="background-color: white;">
        <h3 style=" padding: 10px;">Open thread Devices Overview</h3>
    </nb-layout-header>
</nb-layout>

<router-outlet></router-outlet>